export const GET_CARS_START = 'GET_CARS_START';
export const GET_CARS_REQUEST = 'GET_CARS_REQUEST';
export const GET_CARS_SUCCESS = 'GET_CARS_SUCCESS';
export const GET_CARS_FAIL = 'GET_CARS_FAIL';

export const GET_CAR_START = 'GET_CAR_START';
export const GET_CAR_REQUEST = 'GET_CAR_REQUEST';
export const GET_CAR_SUCCESS = 'GET_CAR_SUCCESS';
export const GET_CAR_FAIL = 'GET_CAR_FAIL';

export const GET_WEBSITES_START = 'GET_WEBSITES_START';
export const GET_WEBSITES_REQUEST = 'GET_WEBSITES_REQUEST';
export const GET_WEBSITES_SUCCESS = 'GET_WEBSITES_SUCCESS';
export const GET_WEBSITES_FAIL = 'GET_WEBSITES_FAIL';

export const GET_WEBSITE_START = 'GET_WEBSITE_START';
export const GET_WEBSITE_REQUEST = 'GET_WEBSITE_REQUEST';
export const GET_WEBSITE_SUCCESS = 'GET_WEBSITE_SUCCESS';
export const GET_WEBSITE_FAIL = 'GET_WEBSITE_FAIL';

export const SET_DEALER = 'SET_DEALER';

export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
